<template>
  <div class="space-y-4">
    <TimeSegmentFilter
      v-for="(route, i) in routes"
      :key="i"
      :title="t('search.filters.departureTo', { city: route.arr.city })"
      :state="state[i]"
      @onTimeFilterUpdate="emit('onFlightFilterChange', $event, i)"
    />
  </div>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n';
  import type { FlightFilterState } from '@aviata/offers-filters-fns';

  import type { searchOffersTypes } from '@/features/search-offers-filter';

  import TimeSegmentFilter from './TimeSegmentFilter.vue';

  defineProps<{
    routes: searchOffersTypes.MappedFlightPoint[];
    state: FlightFilterState[];
  }>();

  const emit = defineEmits<{
    onFlightFilterChange: [
      flightFilterState: Partial<FlightFilterState>,
      flightNumber: number,
    ];
  }>();

  const { t } = useI18n();
</script>
